'use client';
import { jsx } from 'react/jsx-runtime';
import { cx } from '@chakra-ui/utils/cx';
import { useFieldErrorStyles, useFieldContext } from './field-context.mjs';
import { Icon } from '../icon/icon.mjs';
import { forwardRef } from '../system/forward-ref.mjs';

const FieldErrorIcon = forwardRef(
  function FieldErrorIcon2(props, ref) {
    const styles = useFieldErrorStyles();
    const field = useFieldContext();
    if (!field?.isInvalid)
      return null;
    const _className = cx("chakra-form__error-icon", props.className);
    return /* @__PURE__ */ jsx(
      Icon,
      {
        ref,
        "aria-hidden": true,
        ...props,
        __css: styles.icon,
        className: _className,
        children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
          }
        )
      }
    );
  }
);
FieldErrorIcon.displayName = "FieldErrorIcon";

export { FieldErrorIcon };
